// Chapter mark — large Roman numeral + label, used at top of each page section
export default function ChapterMark({ numeral, label, align = "center" }) {
  const alignment =
    align === "left"
      ? "items-start text-left"
      : align === "right"
      ? "items-end text-right"
      : "items-center text-center";
  return (
    <div className={`flex flex-col gap-4 ${alignment}`}>
      <span className="font-couture text-7xl lg:text-8xl text-[var(--gold-deep)] leading-none tracking-tight">
        {numeral}
      </span>
      <span className="flex items-center gap-4">
        <span className="rule-thin" style={{ width: 36 }} />
        <span className="font-marcellus uppercase tracking-[0.46em] text-[0.7rem] text-[var(--ink)]">
          {label}
        </span>
        <span className="rule-thin" style={{ width: 36 }} />
      </span>
    </div>
  );
}
